import { render } from "./Record.vue?vue&type=template&id=50ed9440&scoped=true"
import script from "./Record.vue?vue&type=script&lang=js"
export * from "./Record.vue?vue&type=script&lang=js"

import "./Record.vue?vue&type=style&index=0&id=50ed9440&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50ed9440"]])

export default __exports__